import { render, staticRenderFns } from "./TasksId.vue?vue&type=template&id=78637afb&"
import script from "./TasksId.vue?vue&type=script&lang=js&"
export * from "./TasksId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports